import React from 'react';

import CardArticle from '@elements/CardArticle';
import RichText from '@elements/RichText';
import { getArticleInfo } from '@utils';

import './style.css';

const LocationList = ({ 
  item 
}): JSX.Element => (
  <div className="location-list--main">
    <section className="location-list__inner">
      <RichText bodyRichText={item.mainTitle}/>
      <div className="location-list__body">
        {
          item.locations.map( site => {
            const article = getArticleInfo(site); 

            return (
              <CardArticle
                key={site.contentful_id}
                article={article}
              />
            )
          })
        }
      </div>
      <RichText bodyRichText={item.mainFooter}/>
    </section>
  </div>
);

export default LocationList;
